import React, { useContext } from "react";
import { Navbar } from "react-bootstrap";
import "../../../assets/styles/topbar.scss";
import { COLOR_PRIMARY } from "../../../constants/colors";
import SmuBadge from "../../../utils/smu-badge/SmuBadge";
import SmuProfile from "../../../utils/smu-profile/SmuProfile";
import { StoreContext } from "../../../store/StoreContext";
import { IconHome } from "../../../icons/Icon";
import defaultAvatar from "../../../assets/images/user_default.png";

const Topbar = () => {
  const { loggedUser, isAdmin } = useContext(StoreContext);
  

  const menu = [
    {
      id: 1,
      title: "Ir a portal promocional",
      path: "/promotional-portal/portal/",
      Icon: <IconHome color="#33383F" />,
    },
  ];

  return (
    <Navbar className="topbar-admin">
      <div className="d-flex mx-lg-4 w-100">
        <div className="d-flex my-auto h-100 pe-lg-4">
          <SmuBadge _className="rounded my-auto me-3" color={COLOR_PRIMARY} />
          <div>
            <div className="text-white text-truncate">
              <span className="h5 fw-bolder m-0 me-2">DASHBOARD /</span>
              <span className="fw-bolder">Portal Promocional</span>
            </div>
            <div className="tagline text-truncate">
              Dale un vistazo al resumen que hemos preparado para ti.
            </div>
          </div>
        </div>
        <SmuProfile
          avatar={loggedUser?.avatar || defaultAvatar}
          name={loggedUser?.name || loggedUser?.username}
          menu={menu}
          isAdmin={isAdmin}
          _className="ms-auto"
        />
      </div>
    </Navbar>
  );
};

export default Topbar;
